import {fetchFileBlob} from "../../api/file/FileService";

const IMAGE_EXTENSIONS = new Set([
    "jpg",
    "jpeg",
    "png",
    "gif",
    "webp",
    "bmp",
    "svg",
    "tif",
    "tiff",
    "jpng",
]);

export function getAttachmentExtension(item, fileName) {
    const fromItem = String(item?.ext || "").toLowerCase().replace(/^\./, "");
    if (fromItem) return fromItem;

    const name = fileName || item?.originalName || item?.uploadName || item?.name || "";
    const parts = String(name).split(".");
    if (parts.length < 2) return "";
    return parts.pop().toLowerCase();
}

export function isImageAttachment(item, fileName) {
    if (item?.object?.type?.startsWith?.("image/")) return true;
    return IMAGE_EXTENSIONS.has(getAttachmentExtension(item, fileName));
}

export async function resolveAttachmentPreviewUrl(item, fileName) {
    if (item?.object instanceof Blob) {
        return URL.createObjectURL(item.object);
    }

    const blob = await fetchFileBlob(item);
    return URL.createObjectURL(blob);
}
